import { Middleware } from '@reduxjs/toolkit';

import { extractLanguage } from './lang';
import { getLocale } from './langSlice';

const languageMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  const lang = extractLanguage(getLocale(store.getState()));
  const html = document.querySelector('html');

  if (html && lang && html.getAttribute('lang') !== lang) {
    html.setAttribute('lang', lang);
  }

  return result;
};

export default languageMiddleware;
